import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-mesh">
      <div className="flex gap-1.5 items-end h-12">
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} className="eq-bar w-2 bg-neon-pink rounded-full" style={{ height: "100%", animationDelay: `${i * 0.12}s` }} />
        ))}
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children, admin = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
